import { useDialogStore } from '@ariakit/react/dialog'
import { useState } from 'react'
import { ProPhotosServiceCard } from '@/features/submission-pro-photos-upload/components/pro-photos-service-card'
import type {
	RemapExperienceVetting,
	RemappedItinerariesVetting
} from '../types'
import { ExpProPhotosChangeItineraryPhotoModal } from './exp-pro-photos-change-itinerary-photo-modal'

interface ExpProPhotosItinerariesProps {
	experience: RemapExperienceVetting
}
export const ExpProPhotosItineraries = ({
	experience
}: ExpProPhotosItinerariesProps) => {
	const changePhotoDialog = useDialogStore()
	const [selectedItinerary, setSelectedItinerary] =
		useState<RemappedItinerariesVetting | null>(null)

	return (
		<>
			<div className='my-5 flex w-full flex-col gap-4'>
				{experience.itineraries.map((itinerary) => (
					<ProPhotosServiceCard
						coverImageUrl={itinerary.coverImage?.url}
						description={itinerary.answers.description.answer}
						key={itinerary.id}
						onCardClick={() => {
							setSelectedItinerary(itinerary)
							changePhotoDialog.toggle()
						}}
						title={itinerary.answers.title.answer}
					/>
				))}
			</div>

			{selectedItinerary !== null && (
				<ExpProPhotosChangeItineraryPhotoModal
					experienceId={experience.id}
					galleryId={experience.gallery.id}
					itineraryCoverImageId={selectedItinerary.coverImage?.id}
					itineraryId={selectedItinerary.id}
					itineraryTitle={selectedItinerary.title ?? ''}
					onClose={() => {
						setSelectedItinerary(null)
						changePhotoDialog.toggle()
					}}
					store={changePhotoDialog}
				/>
			)}
		</>
	)
}
